import React, { useState, useEffect } from 'react';
import { Grid, Paper, Typography, Button, Box, List, ListItem, Modal, Autocomplete, TextField, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TransferBondLayout from './tbondlayout';
import { useUser } from '../../services/userContext'; // Import the user context
import { toast } from 'react-toastify';

const LandingPageTbond = () => {
  const navigate = useNavigate();
  const { user } = useUser(); // Access the user context
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    // Scrolls the window to the top when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user && user.info) {
      const agenciesWithCanPost = user.info.agencyDetails?.filter((agency) => agency.canPost === true); // Filter agencies with CanPost
      if (agenciesWithCanPost.length === 1) {
        // Ensure only one agency with CanPost
        let singleAgent = agenciesWithCanPost.map((agency) => ({
          label: `${agency.dbaAgencyName} (${agency.agencyId})`,
          id: agency.agencyId,
        }));
  
        setSelectedAgency(singleAgent[0]);
        localStorage.setItem('selectedAgency', JSON.stringify(singleAgent[0]));
      }
    }
  }, [user]);

  const handlePostTransferBonds = () => {
    if (!user || !user.info) return; // Wait for user info to be loaded
    if (localStorage.getItem('selectedAgency')) {
      navigate('/post-transfer-bond-dashboard');
    }
    else if (user.info.agencyDetails.length > 1) {
      setModalOpen(true);
    }
    else {
      toast.error("You Don't have any Agencies that Can Post. Please contact Bankers if you believe this is an error.");
    }
  };

  const handleAgencySelect = (agency) => {
    setSelectedAgency(agency);
    localStorage.setItem('selectedAgency', JSON.stringify(agency));
    setModalOpen(false);
    navigate('/post-transfer-bond-dashboard');
  };

  if (!user || !user.info) {
    return null; // Render nothing or a loader until user info is available
  }

  const agencyOptions = user.info.agencyDetails
  .filter((agency) => agency.canPost === true) // Filter agencies with CanPost === true
  .map((agency) => ({
    label: `${agency.dbaAgencyName} (${agency.agencyId})`,
    id: agency.agencyId,
  }));

  return (
    <TransferBondLayout>
      <Container maxWidth="lg" sx={{ paddingTop: 4 }}>
      <Box sx={{ padding: 0 }}>
        {/* Request Transfer Bond Section with applied background color */}
        <Paper sx={{
          padding: 3,
          mb: 4,
          borderRadius: 1,
          backgroundColor: '#f9f9f9',
          boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e0e0e0',
        }}>
          <Typography variant="h6" gutterBottom>
            Request Transfer Bond
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            This option allows you to request transfer bonds. Key features include:
          </Typography>
          <List>
            <ListItem>• Submit a new bond request</ListItem>
            <ListItem>• Review existing requests</ListItem>
            <ListItem>• Track request status</ListItem>
          </List>
          <Button variant="contained" color="primary" size="large" fullWidth onClick={() => navigate('/request-transfer-bond-dashboard')}>
            Request Transfer Bond
          </Button>
        </Paper>

        {/* Post Transfer Bonds Section with applied background color */}
        <Paper sx={{
          padding: 3,
          borderRadius: 1,
          backgroundColor: '#f9f9f9',
          boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e0e0e0',
        }}>
          <Typography variant="h6" gutterBottom>
            Post Transfer Bonds
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            This option allows you to post transfer bonds. Key features include:
          </Typography>
          <List>
            <ListItem>• Post a new bond</ListItem>
            <ListItem>• View posted bonds</ListItem>
            <ListItem>• Manage bond listings</ListItem>
          </List>
          <Button variant="contained" color="secondary" size="large" fullWidth onClick={handlePostTransferBonds}>
            Post Transfer Bonds
          </Button>
        </Paper>

        {/* Modal Section */}
        <Modal open={isModalOpen} onClose={() => setModalOpen(false)}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Select Agency
            </Typography>
            <Autocomplete
              options={agencyOptions}
              getOptionLabel={(option) => option.label}
              onChange={(_, newValue) => handleAgencySelect(newValue)}
              renderInput={(params) => <TextField {...params} label="Agency" fullWidth />}
            />
          </Box>
        </Modal>
      </Box>
      </Container>
    </TransferBondLayout>
  );
};

export default LandingPageTbond;
